const atom = require('recoil').atom;

module.exports = {
  terminalGroupState: atom({ key: 'terminalGroupState', default: [] })
};
